export class DigitRoll {
  constructor(difference) {
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.width = 500
    this.height = 100
    this.top = 10
    this.left = 10
    this.innerElement = "cxDigitRoll"
    this.content = "7852366"
    this.fontFamily = "sans-serif"
    this.fontSize = 48
    this.fontWeight = 400
    this.fontColor = "rgba(255, 255, 255, 1)"
    this.bgColorType = "纯色" // 纯色、渐变、边框、无
    this.bgColor = "rgba(0,92,229,1)"
    this.bgStartColor = "rgba(36,209,247,1)"
    this.bgEndColor = "rgba(0,92,230,1)"
    this.borderColor = "rgba(0,92,229,1)"
    this.bgColorlinearGradientAngle = 180
    // this.isFixed = false //false:自适应；true：固定
    // this.numberWidth = 0 // isFixed == true时，该值生效
    this.decimal = 0 // 保留两位小数
    this.showThousandSeparator = false // 显示千位分隔符
    this.showSeparatorBackground = false // 显示分隔符背景
    this.showPrefix = false //显示前缀
    this.prefixContent = ""
    this.prefixFontFamily = "sans-serif"
    this.prefixFontSize = 12
    this.prefixFontWeight = 400
    this.prefixFontColor = "rgba(255, 255, 255, 1)"
    this.prefixFontMarginBottom = 0
    this.prefixFontMarginRight = 0
    this.suffixFontMarginLeft = 0
    this.showSuffix = false //显示后缀
    this.suffixContent = ""
    this.suffixFontFamily ="sans-serif"
    this.suffixFontSize = 12
    this.suffixFontWeight =400
    this.suffixFontColor = "rgba(255, 255, 255, 1)"
    this.suffixFontMarginBottom = 0
    this.rotate = 0
    this.marginRight = 8
    this.digitRollTextAlign = "left"
    this.animateInterval = 10 // 动画间隔时间
    this.animateDuration = 1 // 动画持续时间
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.emptyDataShowLocal = false //空数据时显示自定义内容
    this.emptyContent = "" //自定义空数据内容
    this.scrollBounce = true //动画效果跳动

    this.showIcon = false
    this.iconSrc = ""
    this.iconType = "img"
    this.iconColorIsThemeColor = false
    this.iconColor = "rgba(0,0,0,0.4)"
    this.iconPosition = "right" // left,right
    this.iconSize = 14
    this.iconMargin = 10
    this.iconMarginBottom = 0
    this.resInfo = {}

    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
